module.exports = __webpack_public_path__ + "img/2f_l_twodays@2x.91b6fe7c.png";